/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 19:59:48
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-20 16:52:34
 * @name: 本地存储
 * @Description: 本地存储,长期存在
 * @FilePath: \preSaleNafterSaleBackstage\src\storage\localstorage.js
 * @Author: DESKTOP-1QU67QM
 */
const localstorage = class {
    constructor() {
        this.localstorage_title = 'preSaleNafterSaleBackstage_';
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取登录手机号缓存
     */    
    getLoginTelephone() {
        return localStorage.getItem(this.localstorage_title + 'loginTelephone');
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 设置登录手机号缓存
     */
    setLoginTelephone(loginTelephone) {
        localStorage.setItem(this.localstorage_title + 'loginTelephone', loginTelephone);
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 移除登录手机号缓存
     */
    removeLoginTelephone(loginTelephone) {
        localStorage.removeItem(this.localstorage_title + 'loginTelephone');
    }
}

export default localstorage;